// Copyright (c) Docugami, Inc. All rights reserved.

export enum NavigationGroup {
    UserDocSets = 'UserDocSets',
    Samples = 'Samples',
    ReviewDocs = 'ReviewDocs',
    DocSources = 'DocSources'
}

export enum ReviewDocsId {
    Unassigned = 'Unassigned',
    Error = 'Error'
}

export enum DocSourceId {
    Docugami = "Docugami",
    SharePoint = "SharePoint",
    OneDrive = "OneDrive",
    Box = 'Box',
    Dropbox = 'Dropbox'
}

export enum ExplorerViewType {
    LocalDocSource = 'LocalDocSource',
    RemoteDocSource = 'RemoteDocSource',
    DocSet = 'DocSet',
    Unassigned = 'Unassigned',
    AddDocs = 'AddDocs',
    BrowseSamples = 'BrowseSamples'
}

export enum ExplorerButtonId {
    AddDocs = 'AddDocs',
    BrowseSamples = 'BrowseSamples'
}
